import React from 'react';
import theme, { cn } from '../../styles/theme';

const CategoriaItem = ({ categoria, sucursales, onEdit, onViewSucursales }) => {
  const getBadgeStyles = (estado) => {
    return estado === 'ACTIVO' 
      ? theme.classes.status.active
      : theme.classes.status.inactive;
  };

  const getStatusIcon = (estado) => {
    return estado === 'ACTIVO' ? (
      <svg className="w-3 h-3 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
      </svg>
    ) : (
      <svg className="w-3 h-3 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
      </svg>
    );
  };

  return (
    <tr className={cn(theme.classes.table.row)}>
      {/* Columna ID */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="text-sm font-mono font-semibold text-gray-900 bg-gray-100 px-2 py-1 rounded">
            #{categoria.Id_categoria}
          </div>
        </div>
      </td>

      {/* Columna Nombre */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div>
            <div className="text-sm font-semibold text-gray-900">
              {categoria.Nombre_categoria}
            </div>
            <div className="text-xs text-gray-500 mt-1">
              Nombre de Categoría
            </div>
          </div>
        </div>
      </td>   

      {/* Columna Estado */}
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <span className={cn("inline-flex items-center px-3 py-1 rounded-full text-xs font-medium", getBadgeStyles(categoria.Estado))}>
            {getStatusIcon(categoria.Estado)}
            {categoria.Estado}
          </span>
        </div>
      </td>

      {/* Columna Acciones */}
      <td className="px-6 py-4 whitespace-nowrap text-right">
        <div className="flex items-center justify-end gap-2">
          {/* Botón Editar */}
          <button
            onClick={() => onEdit(categoria)}
            className={cn(
              "group relative inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-1",
              theme.transitions.default
            )}
            title="Editar categoría"
          >
            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            Editar
            
            {/* Tooltip */}
            <span className={cn(
              "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap",
              theme.transitions.default
            )}>
              Modificar esta Categoría
            </span>
          </button>

          {/* Botón de menú de opciones adicionales */}
          <button
            className={cn(
              "group relative inline-flex items-center justify-center p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg",
              theme.transitions.default
            )}
            title="Más opciones"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
            
            <span className={cn(
              "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap",
              theme.transitions.default
            )}>
              Más acciones
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default CategoriaItem;